import Link from "next/link";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  seeAllHref?: string;
  seeAllLabel?: string;
  children?: React.ReactNode;
}

export function SectionHeader({
  title,
  subtitle,
  seeAllHref,
  seeAllLabel = "See all →",
  children,
}: SectionHeaderProps) {
  return (
    <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2 px-4 lg:px-0">
      <h2
        className="font-semibold text-[0.7rem] text-[var(--explore-text-muted)] uppercase tracking-[0.1em]"
        style={{ fontFamily: "var(--homepage-sans-stack)" }}
      >
        {title}
        {subtitle && <span className="ml-1 font-normal">{subtitle}</span>}
      </h2>
      <div className="flex items-center gap-3">
        {children}
        {seeAllHref && (
          <Link
            className="hidden font-medium text-[0.7rem] text-[var(--explore-text-muted)] uppercase tracking-[0.05em] no-underline transition-colors hover:text-[var(--explore-text-secondary)] sm:inline"
            href={seeAllHref}
            style={{ fontFamily: "var(--homepage-sans-stack)" }}
          >
            {seeAllLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
